//SendBackService.ts
import { axiosRequest } from "./AxiosService";
import { ApplicationData } from "../pages/RecordDetail/ApplicationData";


/**
 *  差し戻し処理（SendBackService）
 * ログイン中のユーザーID（userId）と進行中のアクティビティID（activityId）を獲得。
 * @param userId - 現在のユーザーのID
 * @param applicationData - 進行中のアクティビティを特定するために使用される。
 */

export const sendBack = async (
  userId: string,
  applicationData: ApplicationData,
  comment: string
): Promise<boolean> => {
  // ログイン中のuserIdと進行中のactivityIdを獲得
  const applicationEntryId = applicationData.applicationEntryId;

  // userIdとactivityIdを獲得できない場合
  if (!userId || !applicationEntryId) {
    console.error("ユーザーIDまたはアクティビティIDが無効です");
    return false;
  }

  // 引数を設定する
  const options = {
    data: {
      applicationEntryId: applicationEntryId,
      comment: comment,
    },
  };

  try {
    // サーバー通信
    const response: Promise<boolean> = axiosRequest(
      "/sendBack",
      "POST",
      options
    );

    if (response !== undefined) {
      return (await response).valueOf();
    } else {
      return false;
    }
  } catch (error) {
    console.error("差し戻し処理のリクエストエラー:", error);
    return false;
  }
};
